import { render, staticRenderFns } from "./QuotationForm.vue?vue&type=template&id=c2e94fb0&scoped=true"
import script from "./QuotationForm.vue?vue&type=script&lang=js"
export * from "./QuotationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e94fb0",
  null
  
)

export default component.exports